<template>
    <div class="play">
        <div class="play-div">
            <div class="play-box">
                <div v-for="(item, index) in playcateData" :key="index">
                    <div class="play-title">
                        <img src="../assets/play-yanzhi.png" alt="" />
                        <span>{{ item.title }}</span>
                        <!-- <div class="title-like">美女</div>
                        <div class="title-like">日常</div> -->
                    </div>
                    <div class="play-list">
                        <div class="list-box" v-for="oneItem in item.rows" :key="oneItem.id">
                            <div class="box-img" @click="changeDay(oneItem.videoUrl)">
                                <img class="img-bg" :src="oneItem.picUrl" alt="" />
                                <div class="img-time">
                                    <img src="../assets/hu-time.png" alt="" />
                                    <span>{{ oneItem.playTime }}</span>
                                </div>
                            </div>
                            <div class="list-title">
                                <div class="title-info">
                                    {{ oneItem.title }}
                                </div>
                                <div class="title-text">
                                    <div class="text-name">
                                        <img src="../assets/hu-user.png" alt="" />
                                        <span>{{ oneItem.usernickname }}</span>
                                    </div>
                                    <div class="text-name">
                                        <img src="../assets/hu-video.png" alt="" />
                                        <span>{{
                                            oneItem.num > 10000
                                                ? Math.floor(
                                                    oneItem.num / 10000
                                                ) + "万"
                                                : oneItem.num
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="play-page">
                        <el-pagination @current-change="
                            handleCurrentChange(
                                index,
                                item.id,
                                item.currentPage
                            )
                            " :current-page.sync="item.currentPage" :page-size="10" layout="total, prev, pager, next"
                            :total="item.count">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" @close="handleClose"
            class="dialog-style">
            <div class="dialog-video">
                <video-player class="video-player vjs-custom-skin" ref="videoPlayerDia"
                    :options="diaVideoOption"></video-player>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { playacticleApi, playlistApi } from "../api/api.js";
export default {
    name: "PlayRoutine",
    data() {
        return {
            currentPage1: 1,
            playcateData: [],
            playlistData: [],
            dialogVisible: false,
            diaVideoOption: {
                // video.js的配置选项
                controls: true,
                autoplay: true,
                muted: true,
                loop: false,
                width: "100%", // 可以设置为具体的像素值或百分比
                // height: "100%", // 同上
                sources: [
                    {
                        src: "", // 替换为你的视频源
                        type: "video/mp4",
                    },
                ],
                controlBar: {
                    volumeControl: true,
                    remainingTimeDisplay: false,
                },
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
            },
        };
    },
    components: {},
    mounted() {
        this.playacticle();
    },
    methods: {
        handleCurrentChange(index, catId, currentPage) {
            this.playlistPage(index, catId, currentPage);
        },
        changeDay(url) {
            this.dialogVisible = true;
            this.diaVideoOption.sources[0].src = url;
            setTimeout(() => {
                this.$refs.videoPlayerDia.player.play(); // 停止视频播放
            }, 100);
        },
        handleClose() {
            this.$refs.videoPlayerDia.player.currentTime(0); // 将视频时间重置为0
            this.$refs.videoPlayerDia.player.pause(); // 停止视频播放
            this.dialogVisible = false;
        },
        async playacticle() {
            const res = await playacticleApi();
            // this.playcateData = res.data.data.playcate;
            var playcateData = res.data.data.playcate;
            playcateData?.map((item) => {
                // item["rows"] = [];
                item["currentPage"] = 1;
                item["rows"] = res.data.data.playlist?.filter(it => it.cateId == item.id) || []

                // res.data.data.playlist?.map((it) => {
                //     if (it.cateId == item.id) {
                //         item["rows"].push(it);
                //     }
                // });
            });
            this.playcateData = playcateData || [];
        },
        async playlistPage(index, cateId, currentPage) {
            const res = await playlistApi({
                cateId,
                pageindex: currentPage,
                pagesize: 10,
            });
            // console.log(res, "playlistPage");
            this.playcateData[index]["rows"] = res.data.data.records;
            this.playcateData[index]["currentPage"] = res.data.data.current;
        },
    },
};
</script>
<style lang="scss" scoped>
.play {
    width: 100vw;
    height: 1403px;
    background: url("../assets/active-bg.png");
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
}

.play-div {
    width: 70%;
    height: 90%;
    padding-right: 60px;
    overflow-y: auto;
    /* 垂直方向显示滚动条 */
    overflow-x: hidden;
    /* 隐藏水平方向的滚动条，如果需要的话 */
    // overflow: auto;
    scrollbar-width: auto;
    /* Firefox */
    -ms-overflow-style: auto;

    /* Internet Explorer 10+ */
    .play-box {
        .play-title {
            display: flex;
            align-items: center;
            padding-bottom: 10px;
            border-bottom: 1px solid #6d6d6d;

            img {
                width: 32px;
                height: 32px;
            }

            span {
                font-size: 18px;
                color: #000000;
                font-weight: bold;
                padding-left: 10px;
            }

            .title-like {
                width: 90px;
                height: 30px;
                border: 1px solid #5a5555;
                text-align: center;
                line-height: 30px;
                border-radius: 15px;
                color: #5a5555;
                margin-left: 15px;
                font-size: 16px;
            }
        }

        .play-list {
            display: flex;
            flex-wrap: wrap;

            .list-box {
                width: 185px;
                margin: 30px 3%;

                .box-img {
                    width: 100%;
                    height: 250px;
                    position: relative;

                    .img-bg {
                        width: 100%;
                        height: 100%;
                        border-radius: 5px;
                    }

                    .img-time {
                        position: absolute;
                        bottom: 2%;
                        right: 7%;
                        display: flex;
                        align-items: center;

                        span {
                            font-size: 14px;
                            color: #fff;
                            padding-left: 5px;
                        }
                    }
                }

                .list-title {
                    .title-info {
                        color: #fff;
                        font-size: 16px;
                        padding: 10px 0;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 隐藏超出的内容 */
                        text-overflow: ellipsis;
                        /* 用省略号表示被隐藏的部分 */
                        max-width: 100%;
                        /* 设置最大宽度以限制文本的显示长度 */
                    }

                    .title-text {
                        font-size: 14px;
                        color: #838383;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .text-name {
                            display: flex;
                            align-items: center;

                            img {
                                width: 12px;
                                height: 12px;
                                padding-right: 5px;
                            }
                        }
                    }
                }
            }
        }

        .play-page {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-bottom: 20px;
        }
    }
}

::-webkit-scrollbar {
    /* 隐藏默认的滚动条 */
    -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
    /* 设置垂直滚动条宽度 */
    width: 10px;
}

::-webkit-scrollbar:horizontal {
    /* 设置水平滚动条厚度 */
    height: 2px;
}

::-webkit-scrollbar-thumb {
    /* 滚动条的其他样式定制，注意，这个一定也要定制，否则就是一个透明的滚动条 */
    border-radius: 10px;
    /* 设置滚动条的圆角 */
    background-color: #ff9000;
    /* 设置滚动条的颜色填充 */
}

::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background: #b9b9b9;
}

.dialog-video ::v-deep .video-js {
    height: 500px;
}

/*播放按钮设置成宽高一致，圆形，居中*/
::v-deep .vjs-custom-skin>.video-js .vjs-big-play-button {
    outline: none;
    border: none;
    width: 66px;
    height: 66px !important;
    background-color: rgba(0, 0, 0, 0) !important;
}

::v-deep .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    content: '';
    width: 66px;
    height: 66px;
    background: url('../assets/play.png') no-repeat;
    background-size: 100% 100%;
}

::v-deep .vjs-custom-skin>.video-js .vjs-play-progress:before {
    top: 0;
}
</style>
